import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { connect, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { CHARGE_PRODUCT } from "../../actions/types";
import { webUrl } from "../../helper/globals";
import * as actions from "../../actions/product";
import { useState } from "react";
import PleaseLogin from "../modals/PleaseLogin";

function AdditionalChannels(props) {
  const navigate = useNavigate();
  const product = useSelector((state) => state.product);
  const auth = useSelector((state) => state.auth);
  const user = useSelector((state) => state.user);
  const [openModal, setOpenModal] = useState(false);
  function handleClose() {
    setOpenModal(false);
  }
  if (product?.additionalProductList == null && user != null) {
    props.getAdditional(user?.productId);
    console.log(user?.productId);
    // console.log(user.additionalProducts);
    // console.log(product);
  }
  function getProduct(id) {
    let e = product?.additionalProductList?.find((el) => el.productId === id);
    // console.log(e);
    if (e === undefined) {
      return;
    } else {
      return (
        <Form
          key={e?.productId}
          onSubmit={(event) => {
            event.preventDefault();
            props.selectProduct(
              JSON.parse(event.target.additionalproduct.value)
            );
            navigate("/order");
          }}
        >
          <Form.Select name="additionalproduct" style={{ paddingRight: 5 }}>
            {e?.priceList?.map((s) => {
              return (
                <option
                  value={JSON.stringify({
                    orderType: CHARGE_PRODUCT,
                    product: {
                      productName: e?.productName,
                      productId: e?.productId,
                      productImg: e?.productImg,
                      selected: s,
                    },
                    price: e?.isPromotion ? s.promoPrice : s.price,
                  })}
                >
                  {s.month} month {s.price}₮
                </option>
              );
            })}
          </Form.Select>
          {/* <Button
            variant="primary"
            type="submit"
            className="float-right"
            style={{ marginBottom: "10px" }}
          >
            Сонгох
          </Button> */}
        </Form>
      );
    }
  }
  return (
    <Container fluid>
      <Row style={{ textAlign: "justify" }}>
        <Col
          style={{
            display: " flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          xs={12}
          md={6}
        >
          <img src={"https://ddishtv.mn/kinochin.png"} alt="" />
        </Col>
        <Col xs={12} md={6}>
          <Row>
            <h2>Kinochin package</h2>
            <p>
              <p>
                Hollywood, Mongolia and the world's new best movie content with
                high quality of Mongolian sound and video will be received from
                anywhere in Mongolia only on all DDESH movie channels.
              </p>

              <p>
                Number of channels: 15 / 14HD
                <br />
                Package Code: K
                <br />
                Price: 10,000₮/month = 30 days
              </p>
              <p>
                Package renewal instructions: Charge your DDESH smart card, take
                K space from your admin and member number and write the number
                of months to renew and send it to 139898. /Example: K 1/
              </p>
            </p>
          </Row>
          <Row>
            {
              auth.isLoggedIn ? getProduct("111") : ""
              // <Row>
              //   <Button onClick={() => setOpenModal(true)}>Захиалах</Button>
              // </Row>
            }
          </Row>
        </Col>
      </Row>
      <hr />
      <Row style={{ textAlign: "justify" }}>
        <Col
          style={{
            display: " flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          xs={12}
          md={6}
        >
          <img src={"https://ddishtv.mn/fanat.png"} alt="" />
        </Col>
        <Col xs={12} md={6}>
          <Row>
            <h2>Fanat package</h2>
            <p>
              <p>
                Additional set of sports channels <br /> Enjoy Mongolia and the
                world's most popular sports leagues, matches and events with
                thousands of fans in high quality audio and video from anywhere
                in Mongolia only with DDISH.
              </p>
              <p>
                Number of channels: 6 / 5HD
                <br />
                Package Code: C
                <br />
                Price: 10,000₮/month = 30 days
              </p>
              <p>
                Package renewal instructions: Charge your DDESH smart card, get
                C space from your admin and member number, write the number of
                months to renew and send it to 139898. /Example: C 1/
              </p>
            </p>
          </Row>
          <Row>
            {
              auth.isLoggedIn ? getProduct("112") : ""
              // <Row>
              //   <Button onClick={() => setOpenModal(true)}>Захиалах</Button>
              // </Row>
            }
          </Row>
        </Col>
      </Row>

      <hr />
      <Row style={{ textAlign: "justify" }}>
        <Col
          style={{
            display: " flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          xs={12}
          md={6}
        >
          <img
            src={webUrl + "/u/logo/Banner playboy.jpg"}
            alt="playboy"
            style={{ marginBottom: "10px" }}
          />
        </Col>
        <Col
          xs={12}
          md={6}
          style={{
            display: "flex",
            marginBottom: "10px",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Row>
            <h2>Playboy</h2>
            <p>
              Officially licensed Playboy TV featuring adult-only reality TV
              shows, movies and content.
            </p>
          </Row>
          <Row>
            {
              auth.isLoggedIn ? getProduct("26") : ""
              // <Row>
              //   <Button
              //     style={{ marginBottom: "10px" }}
              //     onClick={() => setOpenModal(true)}
              //   >
              //     Захиалах
              //   </Button>
              // </Row>
            }
          </Row>
        </Col>
      </Row>
      <PleaseLogin isOpen={openModal} onHide={handleClose} />
    </Container>
  );
}
const mapActionToProps = (dispatch) => {
  return {
    getAdditional: (id) => dispatch(actions.getAdditionalProduct(id)),
    selectProduct: (product) => dispatch(actions.selectProduct(product)),
  };
};

export default connect(null, mapActionToProps)(AdditionalChannels);
